import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "/api";

const api = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default api;

/**
 * Parse datetime string dari API (format MySQL: "YYYY-MM-DD HH:MM:SS")
 * sebagai WIB (UTC+7) agar konsisten di semua browser.
 */
export const parseWIB = (d) => {
  if (!d) return null;
  // Jika sudah berupa Date object atau ISO string dengan timezone, gunakan langsung
  if (d instanceof Date) return d;
  const s = String(d);
  // Format MySQL datetime: "2026-05-01 23:56:18" → paksa sebagai WIB
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(s)) {
    return new Date(s.replace(" ", "T") + "+07:00");
  }
  return new Date(s);
};
